import KunLoading112 from './src/index'

KunLoading112.install = function (Vue) {
	Vue.component(KunLoading112.name, KunLoading112);
}

export default KunLoading112;
